import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation} from '@angular/core';
import {EmailValidator} from '../../../../../model/email-validator';
import {TranslateService} from '@ngx-translate/core';

/**
 * Component tha permit to seize a reason for a generic action
 */
@Component({
  selector: 'app-notify',
  templateUrl: './notify.component.html',
  styleUrls: ['./notify.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class NotifyComponent implements OnInit {
  @ViewChild('hhhhh', { static: false }) chipInput: ElementRef;
  /**
   * Input visibility of the component
   */
  @Input('display') public display: boolean;
  @Input('showRejectReason') public showRejectReason: boolean;

  /**
   * Output of the component
   */
  @Output() public displayChange: EventEmitter<boolean>;

  /**
   * Output for the reason seized by user
   */
  @Output() public acceptEventEmitter: EventEmitter<string[]>;
  @Output() public rejectEventEmitter: EventEmitter<any>;

  /**
   * Reason seized by user
   */
  public emailList: string[];
  public rejectReason: string;
  public errorMessageLabel: string;
  public errorEmptyListLabel: string;
  public invalidInput: string;
  public emptyList: boolean;

  /**
   * Default constructor, instantiate variables
   */
  constructor(private translate: TranslateService) {
    this.displayChange = new EventEmitter<boolean>();
    this.acceptEventEmitter = new EventEmitter<string[]>();
    this.rejectEventEmitter = new EventEmitter<any>();
  }
  ngOnInit(): void {
    this.invalidInput = '';
    this.rejectReason = '';
    this.emailList = [];
    this.emptyList = false;
    this.translate.get('NOTIFY_COMPONENT.INVALID_EMAIL').subscribe((res: string) => {
      this.errorMessageLabel = res;
    });
    this.translate.get('NOTIFY_COMPONENT.EMPTY_LIST').subscribe((res: string) => {
      this.errorEmptyListLabel = res;
    });
  }

  public testItem(event): void {
    if (!this.isValidMail(event.value)) {
      this.emailList.splice(this.emailList.length - 1, 1);
      this.invalidInput = event.value;
      return;
    }
    this.emptyList = this.emailList.length < 1;
    this.invalidInput = '';
  }
  public checkPendingValue(): void {
    const pendingValue = this.chipInput.nativeElement.getElementsByTagName('input')[0].value;
    if (pendingValue && pendingValue !== '') {
      if (this.isValidMail(pendingValue)) {
        this.emailList.push(pendingValue);
        this.chipInput.nativeElement.getElementsByTagName('input')[0].value = '';
      }
      else {
        this.invalidInput = pendingValue;
      }
    }
  }
  /**
   * Emit acceptation for the generic action and his justification
   */
  public emitAcceptation(): void {
    this.checkPendingValue();
    this.emptyList = this.emailList.length < 1;
    if (this.emptyList) {
      return;
    }
    this.acceptEventEmitter.emit(this.emailList);
    this.displayChange.emit(false);
    this.resetComponent();
  }
  public emitRejection(): void {
    this.checkPendingValue();
    this.emptyList = this.emailList.length < 1;
    if (this.emptyList) {
      return;
    }
    const rejectionInfo = {
      emailList: this.emailList,
      rejectReason: this.rejectReason
    };
    this.rejectEventEmitter.emit(rejectionInfo);
    this.displayChange.emit(false);
    this.resetComponent();
  }
  public isValidMail(mail: string): boolean {
    return EmailValidator.emailIsValid(mail);
  }
  /**
   * Reset component to original state
   */
  public resetComponent(): void {
    this.emailList = [];
    this.rejectReason = '';
    this.invalidInput = '';
  }

}
